export default "__VITE_ASSET__fa138aed__"